import salonService from "@/services/salon";
export default {
  state: {
    salonDefault: {
      title: "",
      date: "",
      location: "",
      time: "",
      active: false,
      image: ""
    },
    salon: {}
  },
  mutations: {
    setSalon(state, payload) {
      state.salon = { ...state.salonDefault, ...payload };
    }
  },
  actions: {
    async setSalon({ commit }, payload) {
      commit("setSalon", payload);
    },
    resetSalon({ commit }) {
      commit("setSalon", {});
    },
    async removeSalon(context, payload) {
      const { id } = payload;
      await salonService.remove(id);
    }
  }
};
